import React, { ReactElement } from 'react';
import {
  Col, Link, Row, Text,
} from 'idsk-react-components';
import './prispevokVestnikaDetailRow.scss';
import routes from '../../../routing/routes';
import PrispevokVestnikaInfo from '../../../model/PrispevokVestnikaInfo';
import PredpisZbierky from '../../../model/PredpisZbierky';

interface Props<T> {
  header: string;
  data?: string | number | T[];
  prispevkyVestnika?: PrispevokVestnikaInfo[];
  vykonavaciePredpisy?: PredpisZbierky[];
  firsColumnSize?: 'one-third' | 'one-quarter';
}

const PrispevokVestnikaDetailRow = (<T, >({
  header,
  data,
  prispevkyVestnika,
  vykonavaciePredpisy,
  firsColumnSize = 'one-third',
}: Props<T>): ReactElement => {
  const secondColumnSize = firsColumnSize === 'one-third' ? 'two-thirds' : 'three-quarters';
  if (prispevkyVestnika?.length > 0) {
    return (
      <Row className="vestnik-detail-row">
        <Col width={firsColumnSize}>
          <Text type="span" className="information-header">{header}</Text>
        </Col>
        <Col width={secondColumnSize}>
          {prispevkyVestnika.length > 1 ? (
            <ul className="li-margin-bottom">
              {prispevkyVestnika.map((prispevokVestnika, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <li key={index}>
                  <Text type="span">{prispevokVestnika.vestnik.skratenyNazov} {prispevokVestnika.cislo}</Text><br />
                  <Link
                    className="link-color link-margin-left"
                    to={routes.prispevokVestnika.detail.withParams(prispevokVestnika.uuid)}
                  >
                    {prispevokVestnika.nazov}
                  </Link>
                </li>
              ))}
            </ul>
          )
            : (
              <>
                <Text type="span">{prispevkyVestnika[0].kratkyNazov} {prispevkyVestnika[0].cislo}</Text><br />
                <Link
                  className="link-color"
                  to={routes.prispevokVestnika.detail.withParams(prispevkyVestnika[0].uuid)}
                >
                  {prispevkyVestnika[0].nazov}
                </Link>
              </>
            )}
        </Col>
      </Row>
    );
  }

  if (vykonavaciePredpisy?.length > 0) {
    return (
      <Row className="vestnik-detail-row">
        <Col width={firsColumnSize}>
          <Text type="span" className="information-header">{header}</Text>
        </Col>
        <Col width={secondColumnSize}>
          <>
            {vykonavaciePredpisy.length > 1 ? (
              <ul>
                {vykonavaciePredpisy.map((predpisZbierky) => (
                  <li key={predpisZbierky.iri}>
                    <div className="vestnik-detail-link-wrapper">
                      <Link
                        className="vestnik-detail-link"
                        size="small"
                        to={`${process.env.REACT_APP_PORTAL_MAIN_URL}${predpisZbierky?.redirectUrl}`}
                        target="_top"
                      >
                        {predpisZbierky?.popis}
                      </Link>
                    </div>
                  </li>
                ))}
              </ul>
            ) : (
              <Link
                className="vestnik-detail-link-single"
                size="small"
                to={`${process.env.REACT_APP_PORTAL_MAIN_URL}${vykonavaciePredpisy[0].redirectUrl}`}
                target="_top"
              >
                {vykonavaciePredpisy[0]?.popis}
              </Link>
            )}
          </>
        </Col>
      </Row>
    );
  }

  if (!data || (typeof data === 'string' && data.trim() === '')) {
    return <></>;
  }

  return (
    <Row className="vestnik-detail-row">
      <Col width={firsColumnSize}>
        <Text type="span" className="information-header">{header}</Text>
      </Col>
      <Col width={secondColumnSize}>
        <Text type="p" className="vestnik-detail-row-text">{data}</Text>
      </Col>
    </Row>
  );
});

export default PrispevokVestnikaDetailRow;
